import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
  Router,
} from "@angular/router";
import { IonModal, ModalController, NavController } from "@ionic/angular";
import { filter, finalize, Subject, Subscription } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AppService } from "src/app/_services/app.service";
import { ClientService } from "src/app/_services/client.service";
import { LocalStorageService } from "src/app/_services/localStorage.service";
import { MessagesService } from "src/app/_services/messages.service";
import { PusherService } from "src/app/_services/pusher.service";
import { KeyboardService } from "src/app/_services/keyboard.service";
import { DemandWaitOverlayCoordinator } from "src/app/_services/demand-wait-overlay-coordinator.service";
import { ParticulierRelanceFlowService } from "src/app/_services/particulier-relance-flow.service";
import { HttpResponse } from "@angular/common/http";
import {
  isDuplicateDemandeSuccess,
} from "src/app/helpers/demande-response";
import { isHostOnActiveIonPage } from "src/app/helpers/ion-page-visibility";

@Component({
  selector: "app-particulier-footer",
  templateUrl: "./particulier-footer.component.html",
  styleUrls: ["./particulier-footer.component.scss"],
  standalone: false,
})
export class ParticulierFooterComponent implements OnInit, OnDestroy {
  @ViewChild("problemCancelModal") problemCancelModal?: IonModal;

  unreadConversations: number = 0;
  confirmDemandModal: any[] = [];
  newDevis = false;
  newDevisId: any;
  newDevisRef: any;
  private deivsSubscription!: Subscription;
  private routerSubscription!: Subscription;
  private keyboardSubscription!: Subscription;
  activatedRouteIndex = 0;
  problemModal = false;
  addDemandModal = false;
  openChackPayment = false;
  freeDemand = false;
  freeDemandClient = false;
  openwithdraw = false;
  acceptedDemandFree: boolean = false;
  destination_type: "final" | "start" = "final";
  problemId: any;
  currentDemandId: any;
  attentModalOpen = false;
  confirmLoadingArrival = false;
  cancelLoadingArrival = false;
  isRelancing = false;
  private lastRelancedFromDemandId: number | null = null;
  showCancleModal: boolean = false;
  removeWithdrawModal: any = null;
  current_demands_count: number = 0;
  undreaded_messages_count: number = 0;
  undreaded_admin_messages_count: number = 0;
  isKeyboardVisible: boolean = false;
  private destroy$ = new Subject<void>();
  constructor(
    private router: Router,
    private messagesService: MessagesService,
    private laravelEchoService: PusherService,
    private localStorageServices: LocalStorageService,
    private pusherService: PusherService,
    private route: ActivatedRoute,
    private modalController: ModalController,
    private clientService: ClientService,
    private appService: AppService,
    private navController: NavController,
    private keyboardService: KeyboardService,
    private cdr: ChangeDetectorRef,
    private hostRef: ElementRef<HTMLElement>,
    private demandWaitCoordinator: DemandWaitOverlayCoordinator,
    private relanceFlow: ParticulierRelanceFlowService
  ) {
    router.events.pipe(takeUntil(this.destroy$)).subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.closeModals();
      }
    });
  }

  ngOnInit() {
    this.subscribeToMeeting();
    this.subscribeToDevis();
    this.subscribeUserUpdated();
    this.getUnreadConversations();
    this.subscribeAttent();
    this.subscribeCancelModal();
    this.subscribeAdminCancelDemande();
    this.subscribeChackPaymentModal();
    this.subscribeAcceptDemande();
    this.subscribewithdrawModal();
    this.subscribeFreeDemandClientModal();
    this.subscribeFreeDemandModal();
    this.subscribeRoutes();
    this.subscribeHomeData();
    this.subscribeToKeyboard();
    this.subscribeRelanceModalRequests();
  }
  subscribeRoutes() {
    this.routerSubscription = this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.handleRouteChange(event.urlAfterRedirects);
      });
  }
  handleRouteChange(url: string) {
    if (url === "/particulier") {
      this.activatedRouteIndex = 0;
    } else if (url.includes("/particulier/messagerie")) {
      this.activatedRouteIndex = 1;
    } else if (url.includes("/particulier/menu")) {
      this.activatedRouteIndex = 2;
    } else if (url.includes("/particulier/track-demands")) {
      this.activatedRouteIndex = 3;
    } else {
      this.activatedRouteIndex = 0;
    }
  }

  /**
   * True when user is on loader, resume-devis, provider-working or services-around
   * and the route demand id matches the given id.
   */
  private isOnDemandPageWithId(demandId: number | string): boolean {
    return this.relanceFlow.matchesDemandPage(demandId);
  }

  subscribeAcceptDemande() {
    this.pusherService.AcceptDemandeObservable().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data) {
        let commerce = data.commerce;
        commerce && this.appService.dispatchModal("FREE_DEMAND_MODAL", true);
      }
    });
  }
  subscribeHomeData() {
    this.appService.homeDataObservable().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data) {
        const {
          current_demands_count,
          undreaded_messages_count,
          undreaded_admin_messages_count,
        } = data;
        this.undreaded_messages_count = undreaded_messages_count ?? 0;
        this.current_demands_count = current_demands_count ?? 0;
      }
    });
  }

  subscribeToKeyboard() {
    this.keyboardSubscription = this.keyboardService.getKeyboardState().subscribe(
      (isVisible: boolean) => {
        this.isKeyboardVisible = isVisible;
      }
    );
  }
  /**
   * Admin cancelled a demand: only navigate to /particulier when user is on
   * loader, resume-devis, provider-working or demande-list (services-around)
   * and the canceled demand id is the same as the demand they are viewing.
   */
  subscribeAdminCancelDemande() {
    this.laravelEchoService
      .dispatcherAdminCancelDemandeObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        if (data == null || data == undefined) return;
        const canceledId =
          data.demande_id ?? data.demand_id ?? data.demande ?? data.id;
        if (canceledId == null || canceledId === undefined) return;
        if (!this.isOnDemandPageWithId(canceledId)) return;
        const currentRoute = this.router.url;
        if (currentRoute !== "/particulier") {
          this.router.navigate(["/particulier"]);
        }
      });
  }
  subscribeChackPaymentModal() {
    this.appService.checkModalObservable().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data != null && data != undefined) {
        this.openChackPayment = data;
      }
    });
  }
  subscribewithdrawModal() {
    this.appService.withdrawObservable().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data != null && data != undefined) {
        this.openwithdraw = data;
        if (data) {
          this.removeWithdrawModal = setTimeout(() => {
            this.appService.dispatchModal("WITHDRAW_MODAL", false);
            this.modalController.dismiss();
          }, 1000 * 2);
        } else {
          if (this.removeWithdrawModal) {
            this.modalController.dismiss();
            clearTimeout(this.removeWithdrawModal);
          }
        }
      }
    });
  }

  subscribeFreeDemandModal() {
    this.appService.freeDemandModalObservable().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data != null && data != undefined) {
        this.freeDemand = data;
        if (data) {
          this.removeWithdrawModal = setTimeout(() => {
            this.appService.dispatchModal("FREE_DEMAND_MODAL", false);
            this.modalController.dismiss();
          }, 1000 * 2);
        } else {
          if (this.removeWithdrawModal) {
            this.modalController.dismiss();
            clearTimeout(this.removeWithdrawModal);
          }
        }
      }
    });
  }
  subscribeFreeDemandClientModal() {
    this.appService.freeDemandClientModalObservable().pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data != null && data != undefined && data != this.freeDemandClient) {
        if (data) {
          this.freeDemandClient = true;
          if (!this.removeWithdrawModal) {
            this.removeWithdrawModal = setTimeout(() => {
              this.appService.dispatchModal("FREE_DEMAND_CLIENT_MODAL", false);
              this.modalController.dismiss();
            }, 1000 * 10);
          }
        } else {
          this.freeDemandClient = false;
          this.modalController.dismiss();
          if (this.removeWithdrawModal) {
            clearTimeout(this.removeWithdrawModal);
            this.appService.dispatchModal("FREE_DEMAND_CLIENT_MODAL", null);
          }
        }
      }
    });
  }

  subscribeCancelModal() {
    this.appService.cancelModalObservable().pipe(takeUntil(this.destroy$)).subscribe((val: any) => {
      if (!val?.open) {
        this.showCancleModal = false;
        this.cdr.detectChanges();
        return;
      }

      const onServicesAround = this.router.url.includes("/services-around/");
      if (onServicesAround) {
        return;
      }

      if (!isHostOnActiveIonPage(this.hostRef.nativeElement)) {
        return;
      }

      this.showCancleModal = true;
      this.cdr.detectChanges();
    });
  }
  handleCancelModal(value: boolean, id: number = 0) {
    this.appService.dispatchModal("CANCEL_DEMAND_MODAL", {
      open: value,
      id: id,
    });
  }
  closeModals() {
    if (this.problemModal) {
      this.relanceFlow.releaseRelanceModalPresentation();
    }
    this.attentModalOpen = false;
    this.problemModal = false;
    this.addDemandModal = false;
    this.newDevis = false;
    this.showCancleModal = false;
    this.confirmDemandModal.length = 0;
    void this.modalController.dismiss(undefined, "navigation").catch(() => undefined);
  }
  subscribeAttent() {
    this.pusherService.DestinationAttentObservable().pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      if (res.demande_id) {
        this.destination_type = res.destination_type;
        const url = this.router.url.split("?")[0];
        const targetUrl = `/particulier/services-around/${res.demande_id}`;
        this.closeModals();
        this.acceptedDemandFree = res.free === 0 ? false : true;
        this.currentDemandId = res.demande_id;
        if (url === targetUrl) {
          this.attentModalOpen = false;
        } else {
          this.attentModalOpen = true;
        }
        this.cdr.detectChanges();
      }
    });
  }
  closeAttentModal() {
    this.attentModalOpen = false;
  }
  handleAddDemandModal(value: boolean) {
    this.addDemandModal = value;
  }

  goToLogin() {
    this.closeModals();
    setTimeout(() => {
      this.router.navigate(["/login"]);
    }, 100);
  }

  addDemandClick() {
    let auth = this.localStorageServices.getToken();
    auth ? this.goTo("domaines-list") : this.handleAddDemandModal(true);
  }

  sendAcceptation() {
    if (this.confirmLoadingArrival || this.cancelLoadingArrival) {
      return;
    }
    const payload = {
      demande_id: this.currentDemandId,
      destination_type: this.destination_type,
    };
    this.confirmLoadingArrival = true;
    this.clientService.confirmProviderArrival(payload).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.confirmLoadingArrival = false;
      })
    ).subscribe({
      next: () => {
        this.closeModals();
        const targetUrl = `/particulier/services-around/${this.currentDemandId}`;
        const currentPath = this.router.url.split("?")[0];
        if (currentPath === targetUrl) {
          this.demandWaitCoordinator.requestOpen(Number(this.currentDemandId));
        } else {
          setTimeout(() => {
            void this.navController.navigateForward([targetUrl], {
              queryParams: { awaitDevis: "1" },
            });
          }, 50);
        }
      },
      error: () => {
        this.attentModalOpen = true;
      },
    });
  }
  notArrived() {
    if (this.confirmLoadingArrival || this.cancelLoadingArrival) {
      return;
    }
    const payload = {
      demande_id: this.currentDemandId,
      destination_type: this.destination_type,
    };
    this.cancelLoadingArrival = true;
    this.clientService.updateArrivedStatus(payload).pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.cancelLoadingArrival = false;
      })
    ).subscribe({
      next: () => {
        this.attentModalOpen = false;
      },
      error: () => { },
    });
  }

  subscribeUserUpdated() {
    this.laravelEchoService
      .dispatcherUserUpdatedObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (data != null && data != undefined) {
          let user = data.data;
          let token = this.localStorageServices.getToken();
          this.localStorageServices.saveAuthData(token || "", user);
        }
      });
  }
  dispatchUpdateUser(userdata: any) {
    let payload = {
      type_event: "UPDATE_USER",
      data: userdata,
    };
    this.laravelEchoService.computeEvents(payload);
  }
  goTo(destination: string) {
    this.closeModals();
    setTimeout(() => {
      this.router.navigate([`particulier/${destination}`]);
    }, 100);
  }
  getUnreadConversations() {
    this.messagesService.getUnreadConversations().subscribe((conv: any) => {
      this.unreadConversations = conv.length;
    });
  }
  subscribeToMeeting() {
    this.laravelEchoService
      .AcceptMeetingDemandObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        if (data.data) {
          this.closeModals();
          this.confirmDemandModal = [data.data];
        } else {
          this.confirmDemandModal = [];
        }
      });
  }
  subscribeToDevis() {
    this.deivsSubscription = this.laravelEchoService
      .DevisCreatedObservabe()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        if (data != null) {
          const currentPath = this.router.url.split("?")[0];
          if (currentPath.includes("/particulier/services-around/")) {
            return;
          }
          const path = this.route.snapshot.routeConfig?.path;
          if (
            path != "devis/:id" &&
            path != "loading/:id" &&
            data != null &&
            data != undefined
          ) {
            this.closeModals();
            this.newDevis = true;
            this.newDevisId = data.data.id;
            this.newDevisRef = data.data.reference;

            return;
          } else {
            this.closeModals();
            this.newDevisId = data.data.id;
            this.newDevisRef = data.data.reference;
          }
        }
      });
  }
  private subscribeRelanceModalRequests(): void {
    this.relanceFlow.relanceModalRequest$
      .pipe(takeUntil(this.destroy$))
      .subscribe((demandId) => {
        this.presentRelanceModal(demandId);
      });
  }

  /** Single relance modal entry point for footer (relance flow requests only). */
  private presentRelanceModal(demandId: number | string): void {
    if (!isHostOnActiveIonPage(this.hostRef.nativeElement)) {
      return;
    }
    if (!this.shouldPresentRelanceModal(demandId)) {
      return;
    }
    if (!this.relanceFlow.tryClaimRelanceModalPresentation(Number(demandId))) {
      return;
    }
    this.closeModals();
    this.problemId = demandId;
    this.problemModal = true;
    this.cdr.detectChanges();
  }

  onProblemCancelModalDismiss(): void {
    this.problemModal = false;
    this.relanceFlow.releaseRelanceModalPresentation();
    this.cdr.detectChanges();
  }

  private shouldPresentRelanceModal(demandId: number | string): boolean {
    if (this.relanceFlow.shouldSuppressCancelModal()) {
      return false;
    }
    return this.isOnDemandPageWithId(demandId);
  }

  private async closeProblemCancelModal(): Promise<void> {
    this.problemModal = false;
    this.relanceFlow.releaseRelanceModalPresentation();
    this.closeModals();
    try {
      await this.problemCancelModal?.dismiss(null, "relance");
    } catch {
      // Modal already dismissed or not presented yet.
    }
    this.cdr.detectChanges();
  }
  goToDemand() {
    this.closeModals();
    this.laravelEchoService.resetDevisCreated();
    this.modalController.dismiss();
    setTimeout(() => {
      this.router.navigate(["/particulier/devis/" + this.newDevisId]);
    }, 100);
  }
  closeConfirmModal() {
    this.confirmDemandModal.length = 0;
  }
  cancle(): void {
    this.problemModal = false;
    this.relanceFlow.releaseRelanceModalPresentation();
    this.localStorageServices.dropClientDemand();
    this.localStorageServices.removeToCreateDemand();
    this.closeModals();
    this.navController.navigateRoot(["/particulier"]);
  }
  validateEndDemande() {
    if (this.isRelancing) {
      return;
    }
    const sourceDemandId = this.problemId;
    if (sourceDemandId == null || sourceDemandId === "") {
      return;
    }
    const payload = {
      demande_id: sourceDemandId,
      status: "RELANCE",
    };
    this.isRelancing = true;
    this.lastRelancedFromDemandId = Number(sourceDemandId);
    this.relanceFlow.beginRelance();
    this.cdr.detectChanges();

    this.clientService.duplicateDemande(payload, sourceDemandId).pipe(
      finalize(() => {
        this.isRelancing = false;
        this.cdr.detectChanges();
      })
    ).subscribe({
      next: (res: any) => {
        if (!isDuplicateDemandeSuccess(res)) {
          this.relanceFlow.endRelance();
          return;
        }
        void this.completeFooterRelance(res, sourceDemandId);
      },
      error: () => {
        this.relanceFlow.endRelance();
        this.cdr.detectChanges();
      },
    });
  }

  private async completeFooterRelance(
    res: HttpResponse<unknown>,
    sourceDemandId: number | string
  ): Promise<void> {
    await this.closeProblemCancelModal();
    await this.relanceFlow.completeDuplicateSuccess(res, sourceDemandId);
    this.cdr.detectChanges();
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.deivsSubscription?.unsubscribe();
    this.keyboardSubscription?.unsubscribe();
    this.routerSubscription?.unsubscribe();
    if (this.removeWithdrawModal) {
      clearTimeout(this.removeWithdrawModal);
      this.removeWithdrawModal = null;
    }
  }
}
